export class Privilege {
    constructor(
        public name?: string,
    ) {
    }
}
